"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  registrationNotPossible: 'Registration is not possible. This social network is already registered in this Object.',
  useAnotherNetwork: 'Use another social network or email to register a new account in a new role',
  canNotUseSameNetworks: 'You cannot use the same social network to log in to the same Object under different roles'
};